import { atom } from 'recoil'


export const createdCorporateIdState = atom<string>({
  key : 'createdCorporateId',
  default : '',
})